import { render, staticRenderFns } from "./NavEnv.vue?vue&type=template&id=5072a154&scoped=true&"
import script from "./NavEnv.vue?vue&type=script&lang=js&"
export * from "./NavEnv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072a154",
  null
  
)

export default component.exports